<!-- 用户金币记录 -->
<template>
  <div class="gold-record">
    <el-row :gutter="20">
      <!-- 左侧导航栏 -->
      <el-col :span="5" class="ucenter-sider">
        <div class="sidebar-container">
          <div class="sidebar-title">会员中心</div>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <div class="collapse-item__title">
                  <i class="el-icon-shopping-cart-2" style="margin-right: 8px; color: #ff6b6b;"></i>
                  交易中心
                </div>
              </template>
              <ul class="collapse-item__ul">
                <li
                  v-for="(item, k) in tradeMenu"
                  :key="k"
                  @click="changeUrl(item)"
                  :class="{ 'active': item.id === activeId }"
                >
                  {{ item.title }}
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-col>
      
      <!-- 右侧内容区 -->
      <el-col :span="19" class="ucenter-content">
        <div class="content-container">
          <!-- 搜索过滤区 -->
          <div class="filter-section">
            <el-form v-model="query" class="filter-form">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="代发订单号">
                    <el-input v-model="query.order_no" placeholder="请输入代发订单号" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="类型">
                    <el-select v-model="query.type" placeholder="请选择类型" style="width: 100%;">
                      <el-option value="0" label="全部"></el-option>
                      <el-option value="1" label="支出"></el-option>
                      <el-option value="2" label="收入"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <el-button
                      type="primary"
                      size="large"
                      @click="queryData"
                      class="search-button"
                    >
                      查询
                    </el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="6">&nbsp;</el-col>
              </el-row>
            </el-form>
          </div>

          <!-- 金币记录列表 -->
          <div class="record-list-section" v-loading="loading" element-loading-text="加载中">
            <div class="section-header">
              <div class="section-title">
                <i class="el-icon-wallet" style="color: #ff6b6b; font-size: 20px;"></i>
                <span style="margin-left: 8px;">金币记录</span>
              </div>
            </div>
            
            <div class="record-table" v-if="goldList.length > 0">
              <div class="table-header">
                <div class="table-row header-row">
                  <div class="table-cell" :span="6">代发订单号</div>
                  <div class="table-cell" :span="6">金币</div>
                  <div class="table-cell" :span="6">备注</div>
                  <div class="table-cell" :span="6">日期</div>
                </div>
              </div>
              
              <div class="table-body">
                <div
                  class="table-row body-row"
                  v-for="(item, index) in goldList"
                  :key="index"
                >
                  <div class="table-cell" :span="6">{{ item.order_no }}</div>
                  <div class="table-cell" :span="6">
                    <span v-if="item.gold < 0" class="expense-amount">{{ item.gold }}</span>
                    <span v-else class="income-amount">+{{ item.gold }}</span>
                  </div>
                  <div class="table-cell" :span="6">{{ item.remark }}</div>
                  <div class="table-cell" :span="6">{{ item.created_at }}</div>
                </div>
              </div>
            </div>
            
            <!-- 空状态 -->
            <div v-else class="empty-state">
              <div class="empty-content">
                <i class="el-icon-wallet" style="font-size: 60px; color: #e0e0e0;"></i>
                <h3>暂无金币记录</h3>
                <p>您的金币记录还是空的！</p>
              </div>
            </div>

            <!-- 分页 -->
            <div class="pagination-container" style="text-align: center; margin-top: 30px;" v-if="goldList.length > 0">
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="query.pageSize"
                :total="totalCount"
                @current-change="currentChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUcenterCollapseItems } from "@/util/common";

export default {
  name: "Gold",
  data() {
    return {
      activeName: "1",
      activeId: 2,
      goldList: [],
      tradeMenu: [],
      loading: true,
      total: [],
      totalCount: 0,
      currentPage: 1, //当前页码
      query: {
        page: 1,
        pageSize: 10,
        uid: 0,
        order_no: "",
        type: "0",
      },
    };
  },
  created() {
    this.tradeMenu = getUcenterCollapseItems();
    this.query.uid = this.$store.getters.getUser.id;
    this.getGoldList();
  },
  mounted() {},
  methods: {
    /**
     * 切换链接
     * @param {*} item
     */
    changeUrl(item) {
      if (item.url) {
        this.activeId = item.id;
        this.$router.push(item.url);
      }
    },
    /**
     * 查询金币
     */
    queryData() {
      this.query.page = 1;
      this.getGoldList();
    },
    /**
     * 异步获取用户金币列表
     */
    async getGoldList() {
      this.loading = true;
      const { data } = await this.$axios.post(
        this.$newApi + "/api/rbh/gold/list",
        this.query
      );
      this.goldList = data.data.data;
      this.totalCount = data.data.total;
      this.loading = false;
    },
    /**
     * 变更页码
     * @param {*} currentPage
     */
    currentChange(currentPage) {
      this.loading = true;
      this.query.page = currentPage;
      this.getGoldList();
    },
  },
};
</script>

<style scoped>
.gold-record {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding: 20px;
  width: 100%;
  overflow-x: hidden;
}

.gold-record .ucenter-sider {
  padding-right: 10px;
}

.sidebar-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  height: 100%;
}

.sidebar-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #ff6b6b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.el-collapse {
  border: none;
}

.collapse-item__title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.collapse-item__ul {
  padding: 10px 0 0 0;
}

.collapse-item__ul li {
  color: #757578;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  padding-left: 1em;
  cursor: pointer;
  border-radius: 6px;
  margin: 4px 0;
  transition: all 0.3s ease;
}

.collapse-item__ul li:hover {
  background-color: #f8f9fa;
  color: #ff6b6b;
  padding-left: 1.5em;
}

.collapse-item__ul .active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white !important;
  padding-left: 1.5em;
}

.gold-record .ucenter-content {
  padding-left: 10px;
}

.content-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

.filter-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  width: 96%;
}

.filter-form .el-form-item {
  margin-bottom: 0;
}

.search-button {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  border: none;
  width: 100%;
  margin-top: 32px; /* Adjust for label alignment */
  padding: 18px 0;
}

.record-list-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  width: 96%;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.record-table {
  width: 100%;
}

.table-header {
  width: 100%;
}

.header-row {
  display: flex;
  background: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
}

.body-row {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  padding: 12px 0;
  transition: background-color 0.3s ease;
}

.body-row:hover {
  background-color: #fafafa;
}

.table-cell {
  flex: 1;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.table-cell:first-child {
  padding-left: 15px;
}

.table-cell:last-child {
  padding-right: 15px;
}

.expense-amount {
  color: #f5222d;
  font-weight: bold;
}

.income-amount {
  color: #52c41a;
  font-weight: bold;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
}

.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.empty-content h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.empty-content p {
  margin: 0;
  font-size: 14px;
  color: #999;
}

.pagination-container {
  margin-top: 30px;
}

/* Element UI 组件样式覆盖 */
.gold-record .el-input__inner {
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.gold-record .el-select .el-input__inner {
  border-radius: 6px;
}

.gold-record .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
}

.gold-record .el-pagination.is-background .btn-next,
.gold-record .el-pagination.is-background .btn-prev,
.gold-record .el-pagination.is-background .el-pager li {
  background: #f8f9fa;
  border-radius: 6px;
  margin: 0 5px;
}

.gold-record .el-pagination.is-background .btn-next:hover,
.gold-record .el-pagination.is-background .btn-prev:hover,
.gold-record .el-pagination.is-background .el-pager li:hover {
  color: #ff6b6b;
}
</style>